import React from 'react';
import * as PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getDateNaissanceInconnueFRFromYYYYMMDD } from 'components/Commun/Form/Date/dateTranformation';

const InformationsPersonnelles = ({ dataInformationsPersonnelles }) => {
    const getNomUsage = () => {
        if (
            dataInformationsPersonnelles.nomUsage &&
            dataInformationsPersonnelles.nomUsage !== dataInformationsPersonnelles.nom
        ) {
            return `${dataInformationsPersonnelles.nomUsage} `;
        }
        return '';
    };

    const getPrenomUsuel = () => {
        if (
            dataInformationsPersonnelles.prenomUsuel &&
            dataInformationsPersonnelles.prenomUsuel !== dataInformationsPersonnelles.prenomUn
        ) {
            return `${dataInformationsPersonnelles.prenomUsuel} `;
        }
        return '';
    };

    const getDateNaissance = () => {
        if (dataInformationsPersonnelles.dateNaissance) {
            return getDateNaissanceInconnueFRFromYYYYMMDD(
                dataInformationsPersonnelles.dateNaissance,
            );
        }
        return '';
    };

    return (
        <>
            <p className="margin-bottom-sm gras">
                {dataInformationsPersonnelles.nom} {getNomUsage()}
                {dataInformationsPersonnelles.prenomUn} {dataInformationsPersonnelles.prenomDeux}{' '}
                {dataInformationsPersonnelles.prenomTrois}{' '}
                {dataInformationsPersonnelles.prenomQuatre} {getPrenomUsuel()}
            </p>
            <p className="margin-bottom-sm">Sexe : {dataInformationsPersonnelles.sexe}</p>
            <p className="margin-bottom-sm gras">
                Né(e) le {getDateNaissance()} à {dataInformationsPersonnelles.lieuNaissance}
                {dataInformationsPersonnelles.codePostalNaissance !== null && (
                    <span> ({dataInformationsPersonnelles.codePostalNaissance})</span>
                )}
                , {dataInformationsPersonnelles.paysNaissance.libelle}
            </p>

            <p className="margin-bottom-sm">
                CNI: Pour des raisons de sécurité informatique, votre pièce d&apos;identité ne peut
                pas être visualisée depuis votre espace personnel. En cas de doute, vous pouvez
                téléverser une nouvelle fois votre pièce d&apos;identité.
            </p>
            <p className="margin-bottom-sm">Courriel : {dataInformationsPersonnelles.mail}</p>
            <p className="margin-bottom-sm">
                Téléphone : {dataInformationsPersonnelles.telephonePrincipal}
            </p>
            {dataInformationsPersonnelles.telephoneSecondaire && (
                <p className="margin-bottom-sm">
                    Téléphone : {dataInformationsPersonnelles.telephoneSecondaire}
                </p>
            )}
        </>
    );
};

InformationsPersonnelles.propTypes = {
    dataInformationsPersonnelles: PropTypes.shape({
        nom: PropTypes.string.isRequired,
        nomUsage: PropTypes.string.isRequired,
        prenomUsuel: PropTypes.string.isRequired,
        prenomUn: PropTypes.string.isRequired,
        prenomDeux: PropTypes.string,
        prenomTrois: PropTypes.string,
        prenomQuatre: PropTypes.string,
        sexe: PropTypes.string,
        dateNaissance: PropTypes.string,
        lieuNaissance: PropTypes.string,
        codePostalNaissance: PropTypes.string,
        paysNaissance: PropTypes.shape({
            libelle: PropTypes.string.isRequired,
        }).isRequired,
        nationalite: PropTypes.shape({
            libelle: PropTypes.string.isRequired,
        }).isRequired,
        telephonePrincipal: PropTypes.string,
        telephoneSecondaire: PropTypes.string,
        mail: PropTypes.string,
    }).isRequired,
};

InformationsPersonnelles.defaultProps = {};

export default connect()(InformationsPersonnelles);
